import thunk from 'redux-thunk';
import { configuratorReducer } from './configurator/reducers';
import { productReducer } from './product/reducers';
import { overviewReducer } from './overview/reducers';
import { orderReducer } from './order/reducers';
import { editOrderReducer } from './editOrder/reducers';
import { globalsReducer } from './globals/reducers';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Recursive function to set all 'isFetching' and 'isOrderFetching' properties to false
const setLoadingToFalse: any = (state: any) => {
  if (state) {
    if (Array.isArray(state)) {
      return state.map((item) => setLoadingToFalse(item));
    } else if (typeof state === 'object') {
      const modified = Object.keys(state).reduce((acc: any, key) => {
        if (key === 'isFetching' || key === 'isOrderFetching') {
          acc[key] = false;
        } else if (typeof state[key] === 'object' || Array.isArray(state)) {
          acc[key] = setLoadingToFalse(state[key]);
        } else {
          acc[key] = state[key];
        }
        return acc;
      }, {});
      return modified;
    }
  }
  return state;
};
// Transform to set all 'isFetching' and 'isOrderFetching' properties to false
const setLoadingFalseTransform = createTransform(
  (inboundState) => inboundState,
  (outboundState, key) => setLoadingToFalse(outboundState),
);


const rootReducer = combineReducers({
  configurator: configuratorReducer,
  product: productReducer,
  overview: overviewReducer,
  order: orderReducer,
  editOrder: editOrderReducer,
  globals: globalsReducer
});

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['editOrder'],
  transforms: [setLoadingFalseTransform],
};

export type RootState = ReturnType<typeof rootReducer>;

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(thunk)),
);

export const persistor = persistStore(store);
